<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-01 16:39:23
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-05-23 17:34:34
 * @FilePath: \sns-user-frontend\src\components\web\followList.vue
 * @Description: 关注/粉丝列表
-->
<template>
  <Drawer v-model="visible">
    <div class="follow-list">
      <Tabs 
        v-model:tabList="tabList"
        :defaultActive="currentTab"
        @getCuttrentTab="getCuttrentTab"
      >
        <template #default="{item, index}">
          <div class="follow-item-list">
            <div class="follow-item"
              v-for="(item, index) in tabList.find(t => t.name === currentTab).list"
              :key="item.uid"
            >
              <Avatar 
                :avatarInfo="{
                  id: item.uid,
                  avatar: item.avatar
                }"
                :size="40"
                :iconSize="12"
              >
                <span class="nickname">{{item.nickname}}</span>
              </Avatar>
              <Follow 
                :relation="item.relation" 
                :uid="item.uid"
                @change="(e) => {onChangeFollowStatus(e, index)}"
                :followFrom="currentTab"
              />
            </div>
          </div>
        </template>
      </Tabs>
      <pageStatus v-if="listStatus" :status="listStatus"/>
      <el-pagination
        v-if="showPagination"
        v-model:current-page="currentPaginationData.page"
        v-model:page-size="currentPaginationData.limit"
        :small="false"
        layout="prev, pager, next, jumper"
        :total="currentPaginationData.total"
        @current-change="queryFollowList"
        :hide-on-single-page="true"
      />
    </div>
  </Drawer>
</template>

<script setup>

import Drawer from './drawer'
import Avatar from '../avatar'
import Tabs from '@/components/web/tabs'

import http from '@/service'

import { watch, ref, reactive, onMounted, nextTick, onUnmounted, onDeactivated } from 'vue';

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  uid: {
    type: String,
    default: ''
  },
  listType: {
    type: String,
    default: 'following'
  }
})

const visible = ref(false)
// 展示分页器
const showPagination = ref(false)
const listStatus = ref('')


// 分页数据
let currentPaginationData = ref({
  page: 1,
  limit: 15,
  total: 0
})

// 获取关注列表
const followingOnload = async (params) => {
  listStatus.value = ''

  showPagination.value = false
  const { code, data, msg} = await http.getFollowingList(params)
  const { rows = [], total } = data || {}
  if (code !== 200) {
    listStatus.value = 'error'
  }
  if (code === 200 && !rows.length) {
    listStatus.value = 'noContent'
  }
  currentPaginationData.value.total = total
  currentPaginationData.value.page = params.page
  return rows.length ? rows : []
}

// 获取粉丝列表
const followOnload = async (params) => {
  listStatus.value = ''

  showPagination.value = false
  const { code, data, msg} = await http.getFollowerList(params)
  const { rows = [], total } = data || {}
  if (code !== 200) {
    listStatus.value = 'error'
  }
  if (code === 200 && !rows.length) {
    listStatus.value = 'noContent'
  }
  currentPaginationData.value.total = total
  currentPaginationData.value.page = params.page
  return rows.length ? rows : []
}

// 标签页列表参数初始化
const tabList = reactive([{
  name: 'following',
  list: [],
  params: {
    page: 1,
    limit: 15,
    uid: props.uid
  },
  config: {}
}, {
  name: 'follower',
  list: [],
  params: {
    page: 1,
    limit: 15,
    uid: props.uid
  },
  config: {}
}])


// 获取当前激活标签页
const currentTab = ref('following')
const getCuttrentTab = async (val) => {
  // 激活标签
  currentTab.value = val
  // 获取激活选项
  const activeTab = tabList.find(t => t.name === val)
  const params = activeTab.params
  // 切换前清除数据
  activeTab.list = val === 'following' ? await followingOnload(params) : await followOnload(params)
  // 加载完成再显示分页器
  showPagination.value = true
}

// 修改关注状态
const onChangeFollowStatus = ({ relation }, index) => {
  const activeTab = tabList.find(t => t.name === currentTab.value)
  activeTab.list[index].relation = relation
}

// 页数切换
const queryFollowList = async (pageIndex) => {
  // 重置滚动高度
  document.querySelector('.el-drawer__body').scrollTop = 0
  const activeTab = tabList.find(t => t.name === currentTab.value)
  const params = activeTab.params
  params.page = pageIndex
  activeTab.list = currentTab.value === 'following' ? await followingOnload(params) : await followOnload(params)
  showPagination.value = true
}

watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val) {
    nextTick(() => {
      currentTab.value = props.listType
      queryFollowList()
    })
  }
})


watch(() => visible.value, (val) => {
  emit('update:modelValue', val)
})


onDeactivated(() => {
  visible.value = false
})

</script>

<style lang="postcss" scoped>
.follow-list {
  width: 792px;
  height: 100%;
  margin: 0 auto;
  :deep(.var-tabs) {
    .var-tabs__tab-wrap {
      width: 792px;
      display: flex;
      justify-content: center;
    }
  }
  :deep(.var-tab) {
    --tab-font-size: 16px !important;
    --tab-padding: 0px;
    height: 28px;
    line-height: 100%;
    margin-right: 48px;
    flex-shrink: 0 !important;
    width: fit-content;
    margin: 0 106px;
    flex: unset;
    :deep(.el-tabs__item) {
      user-select: none;
      padding: 0 48px 0 0;
      margin-bottom: 12px;
    }
    :deep(.el-tabs__header) {
      margin-bottom: 16px;
    }
    :deep(.el-tabs__active-bar) {
      background-color: var(--theme);
    }
  }

  .follow-item-list {
    .follow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 76px;
      .nickname {
        margin-left: 12px;
      }
    }
  }
}

</style>